module.exports = __webpack_public_path__ + "img/smile-gallery-08.1a594f54.jpg";